export const PORTAL_ID = 'portal'
